export default {
  "labels": {
    "averageShiftTime": "Average shift",
    "quantityLongRest": "48 hours rests",
    "drivenTimeMidnight": "Driving hours between 0:00 and 6:00",
    "drivenTimeSunRise": "Driving hours between 3:00 and 5:00",
    "shiftOverThreshPercentage": "Shifts above 12 hours",
    "startShiftDifferenceTime": "Beginning of shift difference",
    "lowerRestTime": "Unfulfilled 8-hour breaks after starting a day",
    "lowerRestTimeQuantity": "Number of times that, after starting the day, the legal minimum break of 8 continuous hours is not met in the 24 hours prior to the start of the day.",
    "lowerRestTimeAverage": "Average of the number of times that, after starting the day, the minimum legal break of 8 continuous hours is not met in the 24 hours prior to the start of the day.",
    "detailMainIndicators": "Main indications detail",
    "startShift": "Opening hours schedules",
    "rotation": "Rotation",
    "shiftLength": "Shift’s length",
    "consecutiveWorkingDays": "Consecutive worked days",
    "evFatigue": "FATIGUE EVENT",
    "noteDaily": "DAILY GRADE",
    "averageShiftTimeText": "Average duration in hours of the drivers' daily shifts.",
    "quantityLongRestTextDriverView": "Number of 48-hour breaks in the selected interval.",
    "quantityLongRestText": "Average number of 48-hour breaks for each driver in the selected interval.",
    "drivenTimeMidnightText": "Average hours driven in this interval, representing night driving.",
    "drivenTimeSunRiseText": "Average hours driven in this interval, representing critical night driving. At this time there is up to 20 times more probability of having an accident, so it is important to monitor it.",
    "shiftOverThreshPercentageText": "Percentage of daily shifts greater than 12 hours, from the start of the shift to the end of it.",
    "startShiftDifferenceTimeText": "Difference in hours between the start times of one day and the next day. For example, if a driver starts work at 7:30 a.m. one day and 9:30 a.m. the next, this difference is 2 hours.",
    "lowerRestTimePercentageText": "Percentage of breaks that do not meet the legal minimum of 8 hours of continuous rest.",
    "startDay": "Start of the day at",
    "times": "times",
    "timeDay": "Time of the day",
    "betweenStartShifts": "between start of shifts",
    "hoursBetweenStartShifts": "Hours between start of shifts",
    "durationDay": "Duration of the day",
    "durationHours": "Duration (hours)",
    "days": "Days",
    "consecutive": "consecutive",
    "consecutiveDays": "Consecutive days"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/fatigue/fatigueIndicators.js